import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../common/ConfirmationModal/ConfirmationModal';
import {
  useStudentSubmissionDispatch,
  useStudentSubmissionState,
} from './StudentSubmissionPageContext';

const UnsavedChangesSubmissionConfirmationModal = () => {
  const { t } = useTranslation();
  const dispatch = useStudentSubmissionDispatch();
  const {
    unsavedChangesConfirmationPayload,
    isUnsavedChangesSubmissionConfirmationOpen,
  } = useStudentSubmissionState();

  return (
    isUnsavedChangesSubmissionConfirmationOpen && (
      <div data-testid="confirmation-modal">
        <ConfirmationModal
          lang="en"
          loading={false}
          onClose={() =>
            dispatch({ type: 'closeUnsavedChangesSubmissionConfirmation' })
          }
          onConfirm={() => {
            dispatch({ type: 'closeUnsavedChangesSubmissionConfirmation' });
            unsavedChangesConfirmationPayload.action();
          }}
          title={t('Confirm')}
          buttonTextConfirm={t('Discard')}
          buttonTextCancel={t('Cancel')}
        >
          <span>{unsavedChangesConfirmationPayload.message}</span>
        </ConfirmationModal>
      </div>
    )
  );
};

export default UnsavedChangesSubmissionConfirmationModal;
